import PropTypes from 'prop-types'

const SiteUrlPropTypes = PropTypes.shape({
  individualSettingYn: PropTypes.oneOf(['Y', 'N']).isRequired,
  mobileSiteYn: PropTypes.oneOf(['Y', 'N']),
  pcSiteYn: PropTypes.oneOf(['Y', 'N']),
  pcUrl: PropTypes.shape({
    protocol: PropTypes.string,
    url: PropTypes.string,
  }),
  mobileUrl: PropTypes.shape({
    protocol: PropTypes.string,
    url: PropTypes.string,
  }),
})
export default SiteUrlPropTypes
